import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import { combineReducers } from "redux";

import AlertReducer from "./Alerts/reducer";
import AuthReducer from "./Auth/reducer";
import UserReducer from "./Users/reducer";
import RoleReducer from "./Roles/reducer";
import ItemReducer from "./Items/reducer";
import usePreventReducer from "./usePrevent/reducer";
import CareHomeGroupsReducer from "./CareHomeGroups/reducer";
import HomesReducer from "./Homes/reducer";
import EnquiriesReducer from "./Enquiries/reducer";
import CareHearthReducer from "./CareHearth/reducer";
import CareHearthBuyersReducer from "./CareHearthBuyers/reducer";
import CareHearthInsightsReducer from "./CareHearthInsights/reducer";
import NewsReducer from "./News/reducer";
import FaqsReducer from "./Faqs/reducer";
import SlickCareProfilesReducer from "./SlickCareProfiles/reducer";
import HomeGroupAdminReducer from "./HomeGroupsAdmin/reducer";
import HomeGroupStaffReducer from "./HomeGroupsStaff/reducer";
import ReviewsReducer from "./Reviews/reducer";
import PagesReducer from "./Pages/reducer";
import BlogsReducer from "./Blogs/reducer";
import ResidenceReducer from "./Residence/reducer";
import LocationBlogsReducer from "./LocationBlogs/reducer";
import TOCReducer from "./TypesOfCare/reducer";
import WebsiteReducer from "./Website/reducer";
import RoomReducer from "./Rooms/reducer";
import SettingsReducer from "./EmailSettings/reducer";
import ReviewsReplyReducer from "./ReviewReply/reducer";
import PackageReducer from "./Package/reducer";
import EmailReducer from "./Email/reducer";
import BundlesReducer from "./Bundles/reducer";
import NotificationReducer from "./Notification/reducer";

const authPersistConfig = {
  key: "AuthReducer",
  storage: storage,
  blacklist: ["isLoggingIn", "isAuthenticating", "isLoggingOut"],
};

const rootReducer = combineReducers({
  AuthReducer: persistReducer(authPersistConfig, AuthReducer),
  UserReducer,
  RoleReducer,
  ItemReducer,
  usePreventReducer,
  AlertReducer,
  CareHomeGroupsReducer,
  HomesReducer,
  EnquiriesReducer,
  CareHearthReducer,
  CareHearthBuyersReducer,
  CareHearthInsightsReducer,
  NewsReducer,
  FaqsReducer,
  SlickCareProfilesReducer,
  HomeGroupAdminReducer,
  HomeGroupStaffReducer,
  ReviewsReducer,
  PagesReducer,
  BlogsReducer,
  ResidenceReducer,
  LocationBlogsReducer,
  TOCReducer,
  WebsiteReducer,
  RoomReducer,
  SettingsReducer,
  ReviewsReplyReducer,
  PackageReducer,
  EmailReducer,
  BundlesReducer,
  NotificationReducer,
});

export default rootReducer;
